var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "dress",
    d: "M5.33335 7.83333H10.6667M4.82901 2.08554L4.46869 2.26571C3.3643 2.8179 2.66669 3.94666 2.66669 5.1814C2.66669 5.54148 2.95858 5.83337 3.31866 5.83337H4.00002C4.7364 5.83337 5.33335 6.43033 5.33335 7.16671V8.03233C5.33335 8.33509 5.23031 8.62884 5.04118 8.86526L3.6893 10.5551C3.02733 11.3826 2.66669 12.4107 2.66669 13.4704V13.8334C2.66669 14.5698 3.26364 15.1667 4.00002 15.1667H12C12.7364 15.1667 13.3334 14.5698 13.3334 13.8334V13.4704C13.3334 12.4107 12.9727 11.3826 12.3107 10.5551L10.9589 8.86526C10.7697 8.62884 10.6667 8.33509 10.6667 8.03233V7.16671C10.6667 6.43033 11.2636 5.83337 12 5.83337H12.6814C13.0415 5.83337 13.3334 5.54148 13.3334 5.1814C13.3334 3.94666 12.6357 2.8179 11.5314 2.26571L11.171 2.08554C10.8698 1.93495 10.5061 1.99398 10.268 2.23209C9.01541 3.48464 6.98463 3.48464 5.73207 2.23209C5.49396 1.99398 5.1302 1.93495 4.82901 2.08554Z",
    stroke: "current",
    strokeWidth: 1.29167,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDress);
export default __webpack_public_path__ + "static/media/dress.cb9848bb27e9d7b19f9718f8c315cc58.svg";
export { ForwardRef as ReactComponent };